import type { App } from 'vue'
import type { Router } from 'vue-router'
import { initReporter, getReporter } from './reporter'
import { setupWebVitals } from './web-vitals'
import { setupNavigationMetrics } from './navigation'
import { setupPageLoad } from './page-load'
import { setupLongTasks } from './long-tasks'
import { setupResources } from './resources'
import { setupErrors } from './errors'
import { setupMemory, destroyMemory } from './memory'
import { setupNetwork, destroyNetwork } from './network'
import { setupComponentPerf } from './component-perf'

export { getDiagnosticsSnapshot } from './diagnostics'

/**
 * 初始化前端性能监控
 *
 * 在 app.use(router) 之后调用一次即可，自动完成全量采集：
 * 1. Core Web Vitals（LCP/CLS/INP/FCP/TTFB）
 * 2. 路由切换耗时
 * 3. API 请求性能
 * 4. 页面加载各阶段细分
 * 5. 主线程长任务
 * 6. 资源加载性能
 * 7. JS 错误
 * 8. 内存使用
 * 9. 网络质量
 * 10. Vue 组件渲染耗时
 *
 * @param router Vue Router 实例
 * @param app Vue App 实例（用于开启组件渲染监控）
 */
export function initMetrics(router: Router, app?: App): void {
  initReporter()
  setupWebVitals()
  setupNavigationMetrics(router)
  setupPageLoad()
  setupLongTasks()
  setupResources()
  setupErrors()
  setupMemory()
  setupNetwork()
  if (app) {
    setupComponentPerf(app)
  }

  window.addEventListener('beforeunload', destroyMetrics)
}

/** 销毁所有监控定时器和事件监听 */
export function destroyMetrics(): void {
  destroyMemory()
  destroyNetwork()
  getReporter()?.destroy()
  window.removeEventListener('beforeunload', destroyMetrics)
}
